import React, { useState, useEffect, useRef } from 'react';
import AddIcon from '@mui/icons-material/Add';
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import * as Yup from 'yup';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  FormControl,
  InputLabel,
  TablePagination,
  TableContainer,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  ButtonGroup,
  Input,
  Tooltip,
  Avatar,
  List,
  ListItem,
  IconButton,
  ListItemAvatar,
  ListItemText,
  Stack,
  Menu,
  Chip
} from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import ExcelFileUpload from '@jumbo/shared/ExcelUpload/ExcelUpload';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import * as XLSX from 'xlsx';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import { Transition } from 'react-d3-speedometer';
import { Close, Download, Edit, RemoveRedEye, RemoveRedEyeOutlined  } from '@mui/icons-material';
import Div from '@jumbo/shared/Div';
import { LoadingButton } from '@mui/lab';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import JumboDemoCard from "@jumbo/components/JumboDemoCard";
import { Link, useNavigate } from 'react-router-dom';
import getTransactionDetail from 'app/services/globleFunction/getTransactionDetail';
import TableView from 'app/shared/Tableview/Tableview';
import modifyArrayOfObjectsKeys from 'app/utils/modifyArrayOfObjectsKeys';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import { BACKEND_APP_URL } from 'app/utils/constants/paths';
import { useCallback } from 'react';
// import { Formik, Form, Field, ErrorMessage } from 'formik';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { invalid } from 'moment';
const validationSchema = Yup.object().shape({
  LAB: Yup.string().required('LAB is required'),
  SHAPE: Yup.string().required('SHAPE is required'),
  // COLOR: Yup.string().required('COLOR is required'),
  // CLARITY: Yup.string().required('CLARITY is required'),
  // RANGE: Yup.string().required('RANGE is required'),
  TO_LAB: Yup.string().required('TO LAB is required'),
  TO_SHAPE: Yup.string().required('TO SHAPE is required'),
  // TO_COLOR: Yup.string().required('TO COLOR is required'),
  // TO_CLARITY: Yup.string().required('TO CLARITY is required'),
  // TO_RANGE: Yup.string().required('TO RANGE is required'),
  TO_DIFFRENCE: Yup.string().required('TO DIFFRENCE is required'),
});

const initialValues = {
  LAB: '',
  SHAPE: '',
  COLOR: '',
  CLARITY: '',
  // RANGE: '',
  TO_LAB: '',
  TO_SHAPE: '',
  TO_COLOR: '',
  TO_CLARITY: '',
  // TO_RANGE: '',
  TO_DIFFRENCE: '',
};




const Discountmap = () => {


  return (
    <>
      <Grid container alignItems={'center'} sx={{ mb: 2 }} justifyContent={'space-between'}>
        <Typography variant="h1" >
          Discount Mapping
        </Typography>
      </Grid>
      <DiscountMapform />
    </>
  );
};



const DiscountMapform = () => {
  const [excelfile, setExcelfile] = useState(null);
  const [discData, setdiscData] = useState(null);
  const [toDiscData, settoDiscData] = useState(null);
  const [tableData, settableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchloading, setfetchloading] = useState(false);
  const [formtype, setformtype] = useState(false);
  const swal = useSwalWrapper();
  const navigate = useNavigate();

  // useEffect(() => {
  //   console.log(discData);
  // }, [discData]);
  const fetchProcessData = async (values) => {
    settableData([])

    let { data } = jwtAuthAxios.post('discount/fromavilableDiscrang', values).then(res => {
      let tmd = []
      res.data.data.map(item => { })
      settableData(res.data.data)
    })
    // console.log(data);
  }
  const handleFormSubmit = async (values) => {
    if (excelfile == null) {
      swal.fire({
        icon: 'error',
        text: 'Please Upload File',
      });
    } else {
      const formData = new FormData();
      formData.append('excelfile', excelfile);
      // setLoading(true)
      setLoading(true);

      // Make the API call with the Excel data
      jwtAuthAxios
        .post('discount/insertDisc', formData)
        .then((response) => {
          // console.log(response.data);
          swal.fire({
            icon: 'success',
            text: response.data.message,
          });
          navigate('/dashboard')

        })
        .catch((error) => {
          swal.fire({
            icon: 'error',
            text: 'Internal server error',
          });
        }).finally((e) => {
          setLoading(false)
        });
    };
    // reader.readAsBinaryString(excelfile);
    // }

    return false;
  };



  return (
    <div>
      <ButtonGroup sx={{ mb: 3 }} variant="outlined" aria-label="outlined primary button group">
        <Button onClick={() => { setformtype(false) }}>Excel Upload</Button>
        <Button onClick={() => { setformtype(true) }}>Discount Mapping</Button>
      </ButtonGroup>
      <Card>
        <CardHeader
          title={<Typography variant="h4">Discount Mapping </Typography>}
          subheader={
            <Typography sx={{ mt: 1, color: 'text.secondary' }}>
              Drag & drop an Excel file here, or click to select one
            </Typography>
          }
          action={<Tooltip title="DownLoad Sample file"><Link to={`${BACKEND_APP_URL}demo/Single_polish_agr_disc.xlsx`} target='_blank'><Avatar><Download /></Avatar></Link></Tooltip>}
        />
        <CardContent
          sx={{
            display: 'flex',
            minWidth: 0,
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: (theme) => theme.palette.action.hover,
          }}
        >

          {formtype ? <DiscountTable />
            : <Formik
              initialValues={initialValues}
              // validationSchema={validationSchema}
              onSubmit={handleFormSubmit}
            >
              {({ isSubmitting, handleChange }) => (
                <Form style={{ display: 'block', width: '100%' }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <ExcelFileUpload
                        onFileUpload={(file) => {
                          setExcelfile(file);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <LoadingButton
                        variant="contained"
                        color="primary"
                        type="submit"
                        loading={loading}
                        disabled={isSubmitting && excelfile != null}
                      >
                        Submit
                      </LoadingButton>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>}

        </CardContent>
      </Card>

      <Div sx={{ mt: 3 }}>
        {fetchloading && <TableSkeleton />}
        {tableData.length > 0 && <TableView body={tableData} />}
      </Div>
    </div>
  );
};

const DiscountTable = () => {
  const [discData, setdiscData] = useState([])
  const [fdialoge, setfdialoge] = useState(false)
  const [vdialoge, setvdialoge] = useState(false)
  const [helperData, sethelperData] = useState(null)
  const [metaData, setmetaData] = useState({})
  const [selectedGrpId, setselectedGrpId] = useState(null);
  const [dialogetype, setdialogetype] = useState(true);
  const [excelfileData, setexcelfileData] = useState(null);
  const [excelfileJSONData, setexcelfileJSONData] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState({});
  const [groupdicbinfloading, setgroupdicbinfloading] = React.useState(false);
  // const open = Boolean(anchorEl);
  useEffect(()=>{
    if(vdialoge == false){
      setselectedGrpId(null);
      setAnchorEl({});
      setdiscData([]);
      setexcelfileData(null);
      setexcelfileJSONData(null);
      setdialogetype(true);
      setgroupdicbinfloading(false);}
  },[vdialoge])
  const init = useCallback(() => {
    sethelperData(null)
    jwtAuthAxios.get('master/getglobleparaval?name=PARTY_DISC_GROUP').then(res => {
      sethelperData(res.data?.rows)
    }).catch(alert)
  }, [helperData])
  useEffect(async () => {
    init();
    const { data } = await jwtAuthAxios.post('discount/avilableDiscrang?params=1');
    setmetaData({ ...metaData, ...data })
  }, [])
  //   const shapes = ['Shape1', 'Shape2', 'Shape3']; // Example array of shapes
  // const labs = ['Lab1', 'Lab2', 'Lab3']; // Example array of labs
  // const ranges = ['Range1', 'Range2', 'Range3']; // Example array of ranges

  const handleSubmit = async (value) => {
    // console.log(selectedGrpId); return
    const { data } = await jwtAuthAxios.post('discount/avilableDiscrang', { ...value, id: selectedGrpId?.FL_GPID });
    setdiscData(data.data)
    // init()

  }
  const swal = useSwalWrapper();
  const handleNewGroup = async (e) => {
    let val = await window.prompt('Please Enter Group Name')
    if (val) {
      await jwtAuthAxios.post('master/getglobleparaval', { type: 'I', FL_NATURE_LIST: '', FL_INV_TYPE_LIST: '', FL_PARA_NAME: 'PARTY_DISC_GROUP', FL_PARA_VALUE: val, FL_NARRATION: '', FL_PARENT_SEQ: 'PARTY_DISC_GROUP' }).then(res => {
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
        init()
      }).catch(alert)
    }
  }
  const handleViewGroup = async (valData) => {
    console.log(valData);
    setselectedGrpId(valData)
    // setmetaData({...metaData,id:valData?.FL_GPID})
    // await jwtAuthAxios.post('discount/fetchgroupdisc',{...metaData,id:valData?.FL_GPID}).then(res=>{
    //   setdiscData(res.data.data.slice(0, 30))
    setvdialoge(true)
    // })
  }
  const handleEditGroup = async (valData) => {
    let val = await window.prompt('Please Enter Group Name', valData?.FL_PARA_VALUE)
    // console.log(valData); return
    // console.log(val);
    if (val) {
      await jwtAuthAxios.post('master/getglobleparaval', { ...valData, type: 'U', FL_NATURE_LIST: '', FL_INV_TYPE_LIST: '', FL_PARA_NAME: 'PARTY_DISC_GROUP', FL_PARA_VALUE: val, FL_NARRATION: '' }).then(res => {
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
        init()
      }).catch(alert)
    }
  }

  const handleDeleteGroup = async (valData) => {
    let val = await window.prompt('Please Confirm Group Name')
    // console.log(valData); return
    // console.log(val);
    if (val == valData?.FL_PARA_VALUE) {
      await jwtAuthAxios.post('master/getglobleparaval', { ...valData, type: 'D', FL_NATURE_LIST: '', FL_INV_TYPE_LIST: '', FL_PARA_NAME: 'PARTY_DISC_GROUP', FL_PARA_VALUE: val, FL_NARRATION: '' }).then(res => {
        swal.fire({
          icon: 'success',
          text: res.data.message,
        });
        init()
      }).catch(alert)
    } else {
      alert('You have enterd invalid group name')
    }
  }
  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };
  const handleFileInputChange = (event) => {
    try {
      // const files = event.target.files;
      const file = event;
  
      const reader = new FileReader();
  
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
  
        const sheetNames = workbook.SheetNames;
        const jsonData = {};
  
        sheetNames.forEach(sheetName => {
          const worksheet = workbook.Sheets[sheetName];
          jsonData[sheetName] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        });
  
        setexcelfileJSONData(jsonData);
      };
  
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.log(error);
    }
  };
  
  useEffect(() => {
    console.log(excelfileJSONData); //&& handleFileInputChange(excelfileData)
  }, [excelfileJSONData])
  useEffect(() => {
    excelfileData && handleFileInputChange(excelfileData)
  }, [excelfileData])
  const setGroupDiscountHandler =async ()=>{
    setgroupdicbinfloading(true)
    const keys = Object.keys(excelfileJSONData);
    let err= keys.filter(s=>s != excelfileJSONData[s][2][0])
    console.log(err);
    if(err.length > 0){
      alert('invalid Sheet Data')
      setexcelfileJSONData(null);
      setgroupdicbinfloading(false);

    }
    else{
      let isError = false;

      for (const key of keys) {
        try {
          if (!isError) { // Check if any error has occurred
            const res = await jwtAuthAxios.post('/discount/partywiseBindDisc', {
              data: excelfileJSONData[key],
              groupno: selectedGrpId?.FL_GPID
            });
      
            let obj = { ...anchorEl }; // Copy the anchorEl object
            obj[key] = 1; // Update the copied object
            setAnchorEl(obj); // Set the updated object
            console.log('anchorEl', obj);
            console.log(res.data);
          } else {
            break; // Abort the process if an error has occurred
          }
        } catch (error) {
          alert(error)
          console.error(error);
          isError = true; // Set the error flag to true
        }
      }
      
    setgroupdicbinfloading(false)
    swal.fire({
      icon: 'success',
      text: 'Discount added successfully',
    });
    setvdialoge(false);
    // setgroupdicbinfloading(true)
    // Object.keys(excelfileJSONData).forEach(async data=>{
    // //   await setTimeout(() => {
    //     // console.log(data);
    //   tmpobj[data]=1
    //   // }, 800);
    // })
    // // tmpobj['curr']= await Object.keys(excelfileJSONData)[2]
    // setAnchorEl(tmpobj)
  }
  }
  return (<Div sx={{ display: 'block', width: '100%' }}>
    <div style={{ textAlign: 'end', display: 'block', width: '100%' }}>
      <Button sx={{ mb: 2 }} onClick={() => setfdialoge(true)} variant="outlined" startIcon={<FilterAltIcon fontSize={'30px'} />} color='primary'>Filter</Button>
      <Button sx={{ mb: 2, ml: 2 }} onClick={handleNewGroup} variant="outlined" startIcon={<AddIcon fontSize={'30px'} />} color='primary'>Create New Group</Button>
    </div>

    <Grid container spacing={2}>
      <List fullWidth sx={{ mb: 2, width: '100%' }}>
        {helperData?.map(item => <Card key={item?.FL_GPID} sx={{ mb: 2, width: '100%' }}><ListItem
          secondaryAction={
            <>
              <IconButton edge="end" sx={{ ml: 2 }} onClick={() => handleViewGroup(item)} aria-label="View">
                <RemoveRedEyeOutlined />
              </IconButton>
              <IconButton edge="end" sx={{ ml: 2 }} onClick={() => handleEditGroup(item)} aria-label="Edit">
                <CreateOutlinedIcon />
              </IconButton>
              <IconButton edge="end" sx={{ ml: 2 }} onClick={() => handleDeleteGroup(item)} aria-label="Delete">
                <DeleteOutlineOutlinedIcon />
              </IconButton>

            </>}>
          <ListItemAvatar>
            <Avatar>
              <Diversity3OutlinedIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={item?.FL_PARA_VALUE}
          />
        </ListItem></Card>)}
      </List>
    </Grid>

    <Dialog maxWidth={'xxl'} fullWidth onClose={() => setvdialoge(false)} open={vdialoge}>
      <DialogTitle >
        <Stack justifyContent={'space-between'} direction={'row'}>
        <Typography variant='h3'>view discount ({selectedGrpId?.FL_PARA_VALUE})</Typography>
        <Button
        variant='contained'
        color='primary'
          onClick={(event) => setdialogetype(!dialogetype)}
          >
       {dialogetype ? 'Upload Discount' :'Search'}
      </Button>
      {/* <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileInputChange}
      />
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={() => {handleUploadClick();setAnchorEl(null)}}><Typography>Update All Discount</Typography></MenuItem>
          <MenuItem onClick={() => setAnchorEl(null)}>Update Single Group Discount</MenuItem>
        </Menu> */}
        </Stack>
      </DialogTitle>
      <DialogContent>

        {dialogetype ? <><Formik initialValues={{ shape: [], lab: [], range: [], }} onSubmit={handleSubmit}>
          {({ values, handleChange }) => (
            <Form>
              <Stack direction={'row'} spacing={2} sx={{ mb: 2, mt: 2 }}>
                <FormControl fullWidth>
                  <InputLabel>Shape</InputLabel>
                  <Select
                    multiple
                    value={values.shape}
                    onChange={handleChange}
                    name="shape"
                    label={'Shape'}
                  >
                    {metaData?.shapes?.map((shape) => (
                      <MenuItem key={shape?.VALUE} value={shape?.VALUE}>
                        {shape?.NAME}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ mb: 2 }} fullWidth>
                  <InputLabel>Lab</InputLabel>
                  <Select
                    multiple
                    value={values.lab}
                    onChange={handleChange}
                    name="lab"
                    label={'lab'}
                  >
                    {metaData?.labs?.map((lab) => (
                      <MenuItem key={lab?.VALUE} value={lab?.VALUE}>
                        {lab?.NAME}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ mb: 2 }} fullWidth>
                  <InputLabel>Range</InputLabel>
                  <Select
                    value={values.range}
                    onChange={handleChange}
                    name="range"
                    label={'range'}
                    multiple
                  >
                    {metaData?.ranges?.map((range) => (
                      <MenuItem key={range?.VALUE} value={range?.VALUE}>
                        {range?.NAME}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button type="submit" sx={{ minWidth: '120px' }} variant="contained" color="primary">
                  Search
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
        
        <Grid container spacing={2}>
          {discData.map((data, i) => <Grid item lg={6}><TableContainer key={i} component={Paper}>
            <Table size='small' border={1} sx={{ textAlign: 'center' }}>
              <TableHead sx={{backgroundColor:(theme)=>theme.palette.primary.main,color:'#fff'}}>
                <TableRow>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}  colSpan={4}>{data.FL_SHAPE_CODE}</TableCell>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}} colSpan={5}>{data.RANGE}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}>{data.FL_LAB_CODE}</TableCell>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}>D</TableCell>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}>E</TableCell>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}>F</TableCell>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}>G</TableCell>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}>H</TableCell>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}>I</TableCell>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}>J</TableCell>
                  <TableCell sx={{color:'#fff',borderColor:'#fff',fontWeight:'400'}}>K</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>VVS1</TableCell>
                  <TableCell>{Number(data[`D-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`E-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`F-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`G-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`H-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`I-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`J-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`K-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>VVS1</TableCell>
                  <TableCell>{Number(data[`D-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`E-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`F-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`G-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`H-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`I-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`J-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`K-VVS1`] || 0).toFixed(2) || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>VVS2</TableCell>
                  <TableCell>{Number(data[`D-VVS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`E-VVS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`F-VVS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`G-VVS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`H-VVS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`I-VVS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`J-VVS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`K-VVS2`] || 0).toFixed(2) || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>VS1</TableCell>
                  <TableCell>{Number(data[`D-VS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`E-VS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`F-VS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`G-VS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`H-VS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`I-VS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`J-VS1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`K-VS1`] || 0).toFixed(2) || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>VS2</TableCell>
                  <TableCell>{Number(data[`D-VS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`E-VS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`F-VS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`G-VS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`H-VS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`I-VS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`J-VS2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`K-VS2`] || 0).toFixed(2) || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>SI1</TableCell>
                  <TableCell>{Number(data[`D-SI1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`E-SI1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`F-SI1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`G-SI1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`H-SI1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`I-SI1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`J-SI1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`K-SI1`] || 0).toFixed(2) || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>SI2</TableCell>
                  <TableCell>{Number(data[`D-SI2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`E-SI2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`F-SI2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`G-SI2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`H-SI2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`I-SI2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`J-SI2`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`K-SI2`] || 0).toFixed(2) || '-'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>I1</TableCell>
                  <TableCell>{Number(data[`D-I1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`E-I1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`F-I1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`G-I1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`H-I1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`I-I1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`J-I1`] || 0).toFixed(2) || '-'}</TableCell>
                  <TableCell>{Number(data[`K-I1`] || 0).toFixed(2) || '-'}</TableCell>
                </TableRow>

              </TableBody>
            </Table>
          </TableContainer></Grid>)}</Grid></>:excelfileJSONData ? <Stack direction={'row'} spacing={3}>{Object.keys(excelfileJSONData).map(d=><LoadingButton  variant="contained"  sx={{borderRadius: '86px',px:3}} color={anchorEl?.[d] ? 'success':'primary'} size='small'>{d}</LoadingButton>)}<LoadingButton loading={groupdicbinfloading}  variant="contained" color="primary" sx={{ml:'auto'}} onClick={setGroupDiscountHandler}>Upload</LoadingButton> <LoadingButton disabled={groupdicbinfloading} variant="contained" color="error" sx={{ml:'auto'}} onClick={()=>setexcelfileJSONData(null)}>Clear</LoadingButton> </Stack> :<ExcelFileUpload onFileUpload={setexcelfileData}/>}
      </DialogContent></Dialog>
    {/* <Dialog maxWidth={'sm'} fullWidth onClose={() => setfdialoge(false)} open={fdialoge}>
      <DialogTitle>Filter Discount</DialogTitle>
      <DialogContent>
        
      </DialogContent>
    </Dialog> */}
  </Div>
  );
};









Discountmap.Modulename = 'discountmap'

export default Discountmap;